const MainPage = () => {
  return <div />;
};

export default MainPage;
